





















import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

@Component
export default class CoverageStatsView extends Vue {
  @(namespace('LocationModule').State('markers'))
  private markers;

  @(namespace('LocationModule').State('tempMarkers'))
  private tempMarkers;

  get totalCoveredSites() {
    let covered = 0;

    for (const site of this.tempMarkers) {
      if (site.coverage) covered++;
    }
    return covered;
  }

  get totalNotCoveredSites() {
    let notCovered = 0;

    for (const site of this.tempMarkers) {
      if (!site.coverage) notCovered++;
    }
    return notCovered;
  }
}
